import React, { useState } from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'

import { KEY_STATUS } from '../../const'
import { styles } from './styles'
import LoadingIndicator from '../../../../../Components/LoadingIndicator/LoadingIndicator'

const ActionButton = ({ row, classes, onRevoke, onCreate, cypressId }) => {
  const [isLoading, setIsLoading] = useState(false)
  if (isLoading) {
    return (
      <div>
        <LoadingIndicator size={14} style={{ height: '14px' }} label={null} />
      </div>
    )
  }
  return (
    <div
      onClick={async () => {
        setIsLoading(true)
        if (row.status === KEY_STATUS.ACTIVE) {
          await onRevoke(row.id)
        } else {
          await onCreate('PRIVATE')
        }
        setIsLoading(false)
      }}
      className={classNames({
        [classes.action]: true,
        [classes.actionRevoke]: row.status === KEY_STATUS.ACTIVE,
        [classes.actionCreate]: row.status === null || row.status === undefined,
      })}
      cypress_id={cypressId}
    >
      {row && row.status === KEY_STATUS.ACTIVE
        ? 'Revoke'
        : row.status === KEY_STATUS.INACTIVE
        ? ''
        : 'Create'}
    </div>
  )
}

export default injectStyles(styles)(ActionButton)
